/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Syncing/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SyncToolLoader from 'DesignSystem/SyncToolLoader/react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Syncing({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/Syncing"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let syncProcessingPageValueData = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'processingPage',
})
let constantData = 'Processing page:'
let syncProcessingPageValueData1 = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'processingPage',
})
let aggregateData = fromAggregate.join(constantData, syncProcessingPageValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Syncing.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SyncToolLoader
  viewPath={`${viewPath}/SyncToolLoader`}
/>
<div
  data-testid="Syncing.Vertical:1"
  data-view-path={viewPath}
 style={{'--mb-1-Z5BUqx': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Syncing.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z5BUqx': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Syncing in progress..."
/>
<fromFlow.When is={syncProcessingPageValueData}>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 data="sync.processingPage"
 data="'Processing page:'"
 data="sync.processingPage"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
 level="h3"
 marginLeft={dtSpaceXs}
/>
</fromFlow.When>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="We are comparing the patients in Greyfinch to the patients in the 3rd party app and will attempt to match them as best we can."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="This may take some time, so if you have other things to do, you can come back to this page later to see the results."
/>
</div>
</div>
{children}
</React.Fragment>)
}